/* eslint-disable @typescript-eslint/no-unused-vars -- Catch variables intentionally unused */
export function safeJSONParse<T>(
  jsonStr: string,
  defaultValue: T | undefined = undefined,
): T {
  try {
    return JSON.parse(jsonStr) as T
  } catch (_err) {
    // JSON parse failed - return default
    return defaultValue as T
  }
}
